import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import {
  ClipboardList,
  History,
  User,
  MapPin,
  X,
  LogOut as LogOutIcon,
} from "lucide-react";

const PrivateAreaList = ({
  setOpenPrivateAreaList,
  onLogout,
  logoutOnly = false,
  onVerifyEmail,
}) => {
  const areaRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (areaRef.current && !areaRef.current.contains(event.target)) {
        setOpenPrivateAreaList(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setOpenPrivateAreaList]);

  const handleVerifyEmail = () => {
    setOpenPrivateAreaList(false);
    onVerifyEmail?.();
  };

  const handleLogout = () => {
    setOpenPrivateAreaList(false);
    onLogout?.();
  };

  return (
    <div ref={areaRef} className="private-area-list floating-card">
      <div className="floating-card__header">
        <div className="floating-card__title">
          {logoutOnly ? "החשבון שלי" : "האזור האישי"}
        </div>
        <button
          type="button"
          className="floating-card__close"
          onClick={() => setOpenPrivateAreaList(false)}
          aria-label="סגירה"
        >
          <X aria-hidden size={18} strokeWidth={2} />
        </button>
      </div>

      {logoutOnly ? (
        <>
          <p className="private-area-list__hint">
            יש{" "}
            <button
              type="button"
              className="private-area-list__verify-link"
              onClick={handleVerifyEmail}
            >
              לאמת את כתובת המייל
            </button>{" "}
            כדי לגשת לאזור האישי.
          </p>
          {onLogout && (
            <button
              type="button"
              className="private-area-list__logout"
              onClick={handleLogout}
            >
              <span className="option__icon" aria-hidden>
                <LogOutIcon size={18} strokeWidth={2} />
              </span>
              התנתקות
            </button>
          )}
        </>
      ) : (
        <>
          <NavLink
            onClick={() => setOpenPrivateAreaList(false)}
            to="/shopping-list"
          >
            <span className="option__icon" aria-hidden>
              <ClipboardList size={18} strokeWidth={2} />
            </span>
            הרשימות שלי
          </NavLink>

          <NavLink onClick={() => setOpenPrivateAreaList(false)} to="/history">
            <span className="option__icon" aria-hidden>
              <History size={18} strokeWidth={2} />
            </span>
            ההזמנות שלי
          </NavLink>

          <NavLink
            onClick={() => setOpenPrivateAreaList(false)}
            to="/private-area"
          >
            <span className="option__icon" aria-hidden>
              <User size={18} strokeWidth={2} />
            </span>
            פרטים אישיים
          </NavLink>

          <NavLink
            onClick={() => setOpenPrivateAreaList(false)}
            to="/private-area/address"
          >
            <span className="option__icon" aria-hidden>
              <MapPin size={18} strokeWidth={2} />
            </span>
            כתובת למשלוח
          </NavLink>

          {onLogout && (
            <>
              <hr className="private-area-list__divider" />
              <button
                type="button"
                className="private-area-list__logout"
                onClick={handleLogout}
              >
                <span className="option__icon" aria-hidden>
                  <LogOutIcon size={18} strokeWidth={2} />
                </span>
                התנתקות
              </button>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default PrivateAreaList;
